import { ChangeEvent } from "react";
import { Button, TextField } from "@mui/material";
import styles from "./login.module.css";
import { UserFormInputType } from "../../interface/form";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { changeisAuthenticatedThunk, inputPasswordThunk, inputUsernameThunk } from "../../redux/auth/thunk";
import { OpenSnackBarWithResultFail, OpenSnackBarWithResultSuccess } from "../../redux/common/snackBar/thunk";
import { axiosAPIWithJson } from "../../util/axios";
import { useNavigate } from "react-router-dom";

function Login() {

    const dispatch = useDispatch<IRootThunkDispatch>();
    const navigate = useNavigate();
    const {username,password} = useSelector((state: IRootState)=>state.userAuth)


function handleAuthForm( event: ChangeEvent<HTMLInputElement>,type:UserFormInputType){
    switch (type){
        case 'username':
            dispatch(inputUsernameThunk(event.target.value))
            break
        case 'password':
            dispatch(inputPasswordThunk(event.target.value))
            break
    }
}

async function handleSubmitLogin(){
    if (!username){
        dispatch(OpenSnackBarWithResultFail('你未有填寫登入名稱'))
    }
    if (!password){
        dispatch(OpenSnackBarWithResultFail('你未有填寫密碼')) 
    }
    const data = {
        username,
        password
    }

    try {
    const result = await axiosAPIWithJson.post('/api/auth/cms',data)
    console.log('result',result)

 
        if (result.data.success){
            localStorage.setItem('loginToken', result.data.token)
            dispatch(changeisAuthenticatedThunk(true))
            dispatch(OpenSnackBarWithResultSuccess(result.data.message))
            navigate("/cms");
    
        }else{
     
            dispatch(OpenSnackBarWithResultFail(result.data.message))
        }
    } catch (error:any) {
        
       dispatch(OpenSnackBarWithResultFail(error.response.data.message as string))
    }


}

    return (
        <>
            <div className={styles.loginOuterContainer}>
                <div>登入</div>
                <TextField 
                required id="outlined-required" 
                label="登入名稱" 
                onChange={(event)=>handleAuthForm(event as ChangeEvent<HTMLInputElement>,'username')}
                
                />
                <TextField
                    required
                    id="outlined-required"
                    label="登入密碼"
                    type="password"
                    onChange={(event)=>handleAuthForm(event as ChangeEvent<HTMLInputElement>,'password')}
                />
                <div>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: "red",
                            color: "white",
                            marginRight: "10px",
                        }}
                    >
                        取消
                    </Button>
                    <Button variant="contained" onClick={handleSubmitLogin}>提交</Button>
                </div>
            </div>

            {/* <User /> */}
        </>
    );
}

export default Login;
